export const COLOR = {
    point1: '#FF4545',
    point2: '#FFF3F1',
    point3: '#FFB7B7',
  
    sub1: '#00A3FF',
    sub2: '#102E60',
  
    white: '#FFFFFF',
    red: '#FF2424',
    green: '#00A256',
  
    blueGray1: '#E7ECF5',
    blueGray2: '#CED6E3',
    blueGray3: '#A1AAB9',
    blueGray5: '#7A828F',
    blueGray7: '#3C4659',
    blueGray8: '#1C2439',
  
    gray10: '#F9F9F9',
    gray20: '#E4E4E4',
    gray30: '#D1D1D1',
    gray40: '#AAAAAA',
    gray50: '#808080',
    gray70: '#404040',
    gray90: '#202020',
  
    black: '#000000'
  }
  